import { h } from 'preact'
import { useContext } from 'preact/hooks'
import { Suspense, lazy } from 'preact/compat';
import Container from '../blocks/Container'
import Overlay from '../blocks/Overlay'
import Spinner from '../blocks/Spinner'
import { Context } from '../context/Context'
import { Views } from '../../enums'

const Default = lazy(() => import(/* webpackChunkName: "gdprModalLayer1" */ './Default'))
const ManageSettings = lazy(() => import(/* webpackChunkName: "gdprModalLayer2" */ './ManageSettings'))
const PartnerSettings = lazy(() => import(/* webpackChunkName: "gdprModalLayer3" */ './PartnerSettings'))

const getComponent = (view: Views) => {
  switch(view) {
    case Views.default: {
      return <Default />
    }
    case Views.manageSettings: {
      return <ManageSettings />
    }
    case Views.partnerSettings: {
      return <PartnerSettings />
    }
    default: {
      return <Default />
    }
  }
}

const Modal = () => {
  const globalState = useContext(Context)
  const { state: { color, view } } = globalState
  return view ? (
    <Overlay>
      <Container color={color} view={view}>
        <Suspense fallback={<Spinner color={color} />}>
          { getComponent(view) }
        </Suspense>
      </Container>
    </Overlay>
  ) : null
}

export default Modal
